import "./index.scss";

import React, { useEffect, useState } from "react";

const Counter = ({ countdownDate = 1610000000000 }) => {
  const [days, setDays] = useState(55);
  const [hours, setHours] = useState(20);
  const [minutes, setMinutes] = useState(15);
  const [seconds, setSeconds] = useState(29);

  useEffect(() => {
    setInterval(() => {
      const currentTime = new Date().getTime();
      const distanceToDate = countdownDate - currentTime;
      const days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
      const hours = Math.floor(distanceToDate / (1000 * 60 * 60)) % 24;
      const minutes = Math.floor(distanceToDate / (1000 * 60)) % 60;
      const seconds = Math.floor(distanceToDate / 1000) % 60;
      setDays(days);
      setHours(hours);
      setMinutes(minutes);
      setSeconds(seconds);
    }, 1000);
  }, []);

  return (
    <div className={`counter`}>
      <p className={`counter__value counter__value--days`}>{days} days</p>
      <p className={`counter__value counter__value--hours`}>{hours} hours</p>
      <p className={`counter__value counter__value--minutes`}>
        {minutes} minutes
      </p>
      <p className={`counter__value counter__value--seconds`}>
        {seconds} seconds
      </p>
    </div>
  );
};

export default Counter;
